module.exports = __webpack_public_path__ + "img/gifta-blog-footer.635bf81.svg";